/* eslint-disable react/require-default-props */
import React from 'react';
import Lottie from 'lottie-react';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import './NewItemSectionStyles.scss';
const namespace = 'whats_new_modal';
export default function NewItemSection({ title, description, animationData, animationHeight, onTalkToSales, onDismiss }) {
    return (React.createElement("div", { className: "new-item-section" },
        React.createElement("div", { className: "new-item-section__header" },
            React.createElement("h2", { className: "new-item-section__title" }, title),
            React.createElement("p", { className: "new-item-section__description" }, description)),
        (onTalkToSales || onDismiss) && (React.createElement("div", { className: "new-item-section__button-wrapper" },
            onTalkToSales && (React.createElement(Button, { type: "button", variant: "primary", onClick: onTalkToSales }, translate('talk_to_sales', { namespace }))),
            onDismiss && (React.createElement(Button, { type: "button", onClick: onDismiss }, translate('dismiss', { namespace }))))),
        React.createElement("div", { className: "new-item-section__animation-wrapper" },
            React.createElement("div", { className: "new-item-section__animation" },
                React.createElement("div", { style: { height: `${animationHeight}px` } },
                    React.createElement(Lottie, { animationData: animationData, loop: true, autoplay: true }))))));
}
